import mori from 'mori';

/**
 * Generates an array of distributions for selecting data based on context
 */
export default function(data, distributions, type, isGeomulti) {
  if (isGeomulti) {
    return mori.transduce(
      mori.comp(
        mori.filter(
          (distribution) => mori.equals(
            mori.getIn(data.config, ['globalRules', 'Map Base Column']),
            mori.get(distribution, 'characteristic')
          )
        ),
        mori.map(
          (distribution) => {
            return distributionSelector(data, distribution, type);
          }
        )
      ),
      mori.completing(mori.conj),
      mori.vector(),
      data.immutableDistributions
    );
  }
  return mori.map(
    (distribution) => {
      return distributionSelector(data, distribution, type);
    },
    distributions
  );
}

function distributionSelector(data, distribution, type) {
  // use the globally selected dataview, or get the column specific one
  const dataviewLabel = type ?
    type.label :
    mori.get(mori.first(mori.filter((header) => {
      // If the distribution has a headerGroup,
      // match the headerGroup AND the characteristic,
      // else, characteristic only.
      return mori.get(distribution, 'headerGroup', false) ?
        mori.equals(
          mori.get(header, 'headerGroup'),
          mori.get(distribution, 'headerGroup')
        ) && mori.equals(
          mori.get(header, 'characteristic'),
          mori.get(distribution, 'characteristic')
        ) : mori.equals(
          mori.get(header, 'characteristic'),
          mori.get(distribution, 'characteristic')
        );
    }, data.immutableHeaders)), 'label');
  return mori.get(distribution, 'headerGroup') === null ?
    mori.set([
      mori.get(distribution, 'characteristic'),
      dataviewLabel,
    ]) :
    mori.set([
      mori.get(distribution, 'headerGroup'),
      mori.get(distribution, 'characteristic'),
      // If label and char. are the same, make label more unique
      // Label/Char will be same if Doc uses only Year values (2016, etc.)
      // TODO: Find a way to handle this better.
      // See: dataReducer.js L109
      (dataviewLabel === mori.get(distribution, 'characteristic') ?
        `_${dataviewLabel}` : dataviewLabel),
    ]);
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/getSelectedDistributions.js